import { featureFlags } from '../config/featureFlags';

/**
 * Check if user is an admin
 * @param {Object|null} user - The current user object
 * @returns {boolean}
 */
export function isAdmin(user) {
  return user?.is_admin === true;
}

/**
 * Check if user can see Reference feature
 * @param {Object|null} user - The current user object
 * @returns {boolean}
 */
export function canSeeReference(user) {
  return isAdmin(user) || featureFlags.referenceEnabledForUsers;
}

/**
 * Check if user can see Training Mode feature
 * @param {Object|null} user - The current user object
 * @returns {boolean}
 */
export function canSeeTrainingMode(user) {
  return isAdmin(user) || featureFlags.trainingEnabledForUsers;
}

/**
 * Check if user can see Knowledge Check feature
 * @param {Object|null} user - The current user object
 * @returns {boolean}
 */
export function canSeeKnowledgeCheck(user) {
  return isAdmin(user) || featureFlags.knowledgeCheckEnabledForUsers;
}

/**
 * Check feature access by feature key
 * @param {Object|null} user - The current user object
 * @param {string} featureKey - The feature flag key
 * @returns {boolean}
 */
export function canAccessFeature(user, featureKey) {
  if (isAdmin(user)) return true;
  return featureFlags[featureKey] === true;
}
